<div class="d-flex justify-content-end">
    <button
        routerLink="/records/request/new"
        class="btn btn-info btn-request-records">
        Request Records
        <i class="fa fa-external-link ms-1"></i>
    </button>
</div>
<div class="row">
    <kno2-table
        class="w-100"
        [columns]="columns()"
        [data]="requests().items"
        [emptyMessage]="emptyMessage">
        <ng-template
            #status
            let-request>
            <span
                class="dashboard-status"
                [class]="request.status | lowercase"
                data-bs-toggle="tooltip"
                title="(Request ID: {{ request.requestId }}) -- ({{ brandDisplayName }} ID: {{ request.kno2Uuid }})">
                {{ request.status }}
            </span>
        </ng-template>
        <ng-template
            #dateSubmitted
            let-request>
            <span
                class="dashboard-date"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                [title]="request.dateSubmitted | localDate | date: 'medium'">
                {{ request.dateSubmitted | localDate | eventReportDate }}
            </span>
        </ng-template>
        <ng-template
            #mailTo
            let-request>
            <kno2-multi-address-snippet [addressString]="request.mailTo" />
        </ng-template>
        <ng-template #emptyMessage>
            <div class="text-center">
                No previous requests.
                <a
                    class="blue-link"
                    routerLink="/records/request/new">
                    Request Records
                </a>
            </div>
        </ng-template>
    </kno2-table>
    <div class="d-flex justify-content-end">
        <kno2-pagination
            [collectionSize]="requests().totalCount"
            [page]="queryOptions().pageStart"
            [pageSize]="queryOptions().pageSize"
            (pageChange)="paginationChange({ pageStart: $event })" />
    </div>
</div>
